const namespaced = true

const state = {}

const actions = {
     async getTheme({dispatch}, id) {
        return await dispatch('database/getItem', {table: 'sessionthemes', id: id}, {root: true})
    },

    async getThemes({dispatch}) {
        let data = await dispatch('database/getMultiple', ['sessions', 'sessionthemes', 'session_theme_links'], {root: true});
        let sessionthemes = [];
        console.log(data)
        for (let i = 0; i < data['sessionthemes'].length; i++) {
            let sessiontheme = data['sessionthemes'][i];
            sessiontheme.count = 0;

            for (let k = 0; k < data['session_theme_links'].length; k++) {
                let sess_theme_link = data['session_theme_links'][k];
                console.log("dasd")
                console.log(sess_theme_link)

                if (sess_theme_link.theme_one_id == sessiontheme.id || sess_theme_link.theme_two_id == sessiontheme.id || sess_theme_link.theme_three_id == sessiontheme.id) {
                    sessiontheme.count++
                }

            }
            sessionthemes.push(sessiontheme);
        }
        return sessionthemes;
    },

    async getSessionsByTheme({dispatch}, id) {
        let data = await dispatch('database/getMultiple', ['sessions', 'sessiontypes', 'session_sessiontype_links', 'locations', 'session_location_links', 'person_roles', 'persons', 'session_presentation_links', 'sessionthemes', 'session_theme_links'], {root: true});
        let sessionsToReturn = [];

        let themelinks = data['session_theme_links'].filter(sessthemelinks => sessthemelinks.theme_one_id == id || sessthemelinks.theme_two_id == id || sessthemelinks.theme_three_id == id);
        themelinks.forEach(themelink => {
            let sessions = data['sessions'].filter(session => session.id == themelink.session_id);

            sessions.forEach(session => {
                //sesstype-block
                let sesstype_link = data['session_sessiontype_links'].filter(sesstypelink => sesstypelink.session_id == session.id)[0];

                let type = data['sessiontypes'].filter(type => type.id == sesstype_link.sessiontype_id)[0];

                session.session_type_text = type.name;
                session.session_type_order = type.order;
                session.is_scientific = type.scientific;
                let sessloc_link = data['session_location_links'].filter(sessloc_link => sessloc_link.session_id == session.id)[0];
                let location = data['locations'].filter(location => location.id == sessloc_link.location_id)[0];
                session.location = location;
                session.location_order = location ? location.order : 0;
                session.chair = []
                session.speakers = [];

                let sess_pres_links = data['session_presentation_links'].filter(sess_pres_link => sess_pres_link.session_id == session.id);
                if (sess_pres_links.length > 0) {
                    sess_pres_links.forEach(sess_pres_link => {
                        let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                        let presroles = data['person_roles'].filter(presrole => presrole.presentation_id == sess_pres_link.presentation_id)
                        sessionroles.forEach(role => {
                            let person = data['persons'].filter(person => person.id == role.person_id)[0];
                            if (person) {
                                person.function = role.function;
                                if (JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                    session.chair.push(person);
                                }
                            }
                        })
                        presroles.forEach(role => {
                            let person = data['persons'].filter(person => person.id == role.person_id)[0];
                            if (person) {
                                person.function = role.function;
                                if (JSON.stringify(session.speakers).indexOf(person.display_name) == -1) {
                                    session.speakers.push(person);
                                }
                            }
                        })
                    })
                } else {
                    let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                    sessionroles.forEach(role => {
                        let person = data['persons'].filter(person => person.id == role.person_id)[0];
                        if (person) {
                            person.function = role.function;
                            if (JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                session.chair.push(person);
                            }
                        }
                    })
                }
                sessionsToReturn.push(session);

            })

        })

        return sessionsToReturn;
    },


    async getAllTypes({dispatch}) {
        return await dispatch('database/getItems', {table: 'sessiontypes'}, {root: true})
    },
    async getType({dispatch}, id) {
        return await dispatch('database/getItem', {table: 'sessiontypes', id: id}, {root: true})
    },
    async getTag({dispatch}, id) {
        let tags = await dispatch('database/getItems', {table: 'tags'}, {root: true})
        return tags.find(tag => tag.id == id || tag.group_id == id)
    },
    async getTags({dispatch}) {
        let data = await dispatch('database/getMultiple', ['sessions', 'tags', 'session_tag_links'], {root: true});
        let tags = [];
        for (let i = 0; i < data['tags'].length; i++) {
            let tag = data['tags'][i];
            tag.count = 0;

            for (let k = 0; k < data['session_tag_links'].length; k++) {
                let sess_tag_link = data['session_tag_links'][k];
                if (tag.id == sess_tag_link.tag_id) {

                    for (let j = 0; j < data['sessions'].length; j++) {
                        let session = data['sessions'][j]
                        if (session.id === sess_tag_link.session_id) {
                            console.log('Tag', tag)
                            tag.count++;
                        }
                    }
                }
            }
            tags.push(tag);
        }
        return tags;
    },
    async getWorkshopTags({dispatch}) {
        let data = await dispatch('database/getMultiple', ['sessions', 'tags', 'session_tag_links'], {root: true});
        let tags = [];
        let sessionsToFilter = data['sessions'].filter(sess => sess.workshop_topic != null);
        for (let i = 0; i < data['sessions'].length; i++) {
            let session = data['sessions'][i];
            let found = tags.find(t => t.title == session.workshop_topic);
            if (!found) {
                tags.push({title: session.workshop_topic, count: 1})
            } else {
                let index = tags.findIndex(t => t.title == session.workshop_topic);
                tags[index].count++
            }
        }
        return tags;
    },


    async getSessionTypes({dispatch}) {
        let data = await dispatch('database/getMultiple', ['sessions', 'sessiontypes', 'session_sessiontype_links'], {root: true});
        let types = [];
        for (let i = 0; i < data['sessiontypes'].length; i++) {
            let type = data['sessiontypes'][i];
            type.count = 0;

            for (let k = 0; k < data['session_sessiontype_links'].length; k++) {
                let sess_type_link = data['session_sessiontype_links'][k];
                if (type.id == sess_type_link.sessiontype_id) {
                    for (let j = 0; j < data['sessions'].length; j++) {
                        let session = data['sessions'][j]
                        if (session.id === sess_type_link.session_id) {
                            type.count++;
                        }
                    }
                }
            }
            if (type.scientific) {
                console.log('gettype', type)
                types.push(type);
            }
        }
        return types;
    },
    async getSessionTopics({dispatch}) {
        let data = await dispatch('database/getMultiple', ['sessions', 'tags', 'session_tag_links'], {root: true});
        let types = [];
        for (let i = 0; i < data['tags'].length; i++) {
            let type = data['tags'][i];
            type.count = 0;

            for (let k = 0; k < data['session_tag_links'].length; k++) {
                let sess_type_link = data['session_tag_links'][k];
                if (type.id == sess_type_link.tag_id) {
                    for (let j = 0; j < data['sessions'].length; j++) {
                        let session = data['sessions'][j]
                        if (session.id === sess_type_link.session_id) {
                            type.count++;
                        }
                    }
                }
            }
            console.log('gettype', type)
            types.push(type);
        }
        return types;
    },


    //V2-ready
    async getSessionsByType({dispatch}, id) {
        let data = await dispatch('database/getMultiple', ['sessions', 'sessiontypes', 'session_sessiontype_links', 'locations', 'session_location_links', 'person_roles', 'persons', 'session_presentation_links'], {root: true});
        let sessionsToReturn = [];
        //sesstype-block
        let sesstype_links = data['session_sessiontype_links'].filter(sesstypelink => sesstypelink.sessiontype_id == id);

        let type = data['sessiontypes'].filter(type => type.id == id)[0];
        sesstype_links.forEach(sesstype_link => {
            let sessions = data['sessions'].filter(session => session.id == sesstype_link.session_id);

            sessions.forEach(session => {


                session.session_type_text = type.name;
                session.session_type_order = type.order;
                session.is_scientific = type.scientific;
                let sessloc_link = data['session_location_links'].filter(sessloc_link => sessloc_link.session_id == session.id)[0];
                let location = data['locations'].filter(location => location.id == sessloc_link.location_id)[0];
                session.location = location;
                session.location_order = location ? location.order : 0;
                session.chair = []
                session.speakers = [];

                let sess_pres_links = data['session_presentation_links'].filter(sess_pres_link => sess_pres_link.session_id == session.id);
                if (sess_pres_links.length > 0) {
                    sess_pres_links.forEach(sess_pres_link => {
                        let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                        let presroles = data['person_roles'].filter(presrole => presrole.presentation_id == sess_pres_link.presentation_id)
                        sessionroles.forEach(role => {
                            let person = data['persons'].filter(person => person.id == role.person_id)[0];
                            if (person) {
                                person.function = role.function;
                                if (JSON.stringify(session.chair).indexOf(person.id) == -1 && person.function != 'Attendee') {
                                    session.chair.push(person);
                                }
                            }
                        })
                        presroles.forEach(role => {
                            let person = data['persons'].filter(person => person.id == role.person_id)[0];
                            if (person) {
                                person.function = role.function;
                                if (JSON.stringify(session.speakers).indexOf(person.display_name) == -1 && person.function != 'Attendee') {
                                    session.speakers.push(person);
                                }
                            }
                        })
                    })
                } else {
                    let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                    sessionroles.forEach(role => {
                        let person = data['persons'].filter(person => person.id == role.person_id)[0];
                        if (person) {
                            person.function = role.function;
                            if (JSON.stringify(session.chair).indexOf(person.id) == -1 && person.function != 'Attendee') {
                                session.chair.push(person);
                            }
                        }
                    })
                }
                sessionsToReturn.push(session);
            })
        })
        return sessionsToReturn;
    },
    async getSessionsByTag({dispatch}, tag) {
        let data = await dispatch('database/getMultiple', ['sessions', 'sessiontypes', 'session_sessiontype_links', 'locations', 'session_location_links', 'person_roles', 'persons', 'session_presentation_links', 'tags', 'session_tag_links'], {root: true});
        let sessionsToReturn = [];

        //let sessions = data['sessions'].filter(session => session.group_id == tag.id || session.session_highlights.indexOf(tag.id) != -1 || session.group_id == tag.group_id);

        let taglinks = data['session_tag_links'].filter(sesstaglinks => sesstaglinks.tag_id == tag);

        taglinks.forEach(taglink => {
            let sessions = data['sessions'].filter(session => session.id == taglink.session_id);

            sessions.forEach(session => {
                //sesstype-block
                let sesstype_link = data['session_sessiontype_links'].filter(sesstypelink => sesstypelink.session_id == session.id)[0];

                if (sesstype_link) {
                    let type = data['sessiontypes'].filter(type => type.id == sesstype_link.sessiontype_id)[0];

                    session.session_type_text = type.name;
                    session.session_type_order = type.order;
                    session.is_scientific = type.scientific;
                }

                let sessloc_link = data['session_location_links'].filter(sessloc_link => sessloc_link.session_id == session.id)[0];
                let location = data['locations'].filter(location => location.id == sessloc_link.location_id)[0];
                session.location = location;
                session.location_order = location ? location.order : 0;
                session.chair = []
                session.speakers = [];

                let sess_pres_links = data['session_presentation_links'].filter(sess_pres_link => sess_pres_link.session_id == session.id);
                if (sess_pres_links.length > 0) {
                    sess_pres_links.forEach(sess_pres_link => {
                        let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                        let presroles = data['person_roles'].filter(presrole => presrole.presentation_id == sess_pres_link.presentation_id)
                        sessionroles.forEach(role => {
                            let person = data['persons'].filter(person => person.id == role.person_id)[0];
                            if (person) {
                                person.function = role.function;
                                if (JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                    session.chair.push(person);
                                }
                            }
                        })
                        presroles.forEach(role => {
                            let person = data['persons'].filter(person => person.id == role.person_id)[0];
                            if (person) {
                                person.function = role.function;
                                if (JSON.stringify(session.speakers).indexOf(person.display_name) == -1) {
                                    session.speakers.push(person);
                                }
                            }
                        })
                    })
                } else {
                    let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                    sessionroles.forEach(role => {
                        let person = data['persons'].filter(person => person.id == role.person_id)[0];
                        if (person) {
                            person.function = role.function;
                            if (JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                session.chair.push(person);
                            }
                        }
                    })
                }
                sessionsToReturn.push(session);

            })

        })

        return sessionsToReturn;
    },

    async getSessionsByWorkshopTag({dispatch}, tag) {
        let data = await dispatch('database/getMultiple', ['sessions', 'sessiontypes', 'session_sessiontype_links', 'locations', 'session_location_links', 'person_roles', 'persons', 'session_presentation_links', 'tags', 'session_tag_links'], {root: true});
        let sessionsToReturn = [];
        let sessions = data['sessions'].filter(session => session.workshop_topic == tag);
        sessions.forEach(session => {
            //sesstype-block
            let sesstype_link = data['session_sessiontype_links'].filter(sesstypelink => sesstypelink.session_id == session.id)[0];

            if (sesstype_link) {
                let type = data['sessiontypes'].filter(type => type.id == sesstype_link.sessiontype_id)[0];

                session.session_type_text = type.name;
                session.session_type_order = type.order;
                session.is_scientific = type.scientific;
            }

            let sessloc_link = data['session_location_links'].filter(sessloc_link => sessloc_link.session_id == session.id)[0];
            let location = data['locations'].filter(location => location.id == sessloc_link.location_id)[0];
            session.location = location;
            session.location_order = location ? location.order : 0;
            session.chair = []
            session.speakers = [];

            let sess_pres_links = data['session_presentation_links'].filter(sess_pres_link => sess_pres_link.session_id == session.id);
            if (sess_pres_links.length > 0) {
                sess_pres_links.forEach(sess_pres_link => {
                    let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                    let presroles = data['person_roles'].filter(presrole => presrole.presentation_id == sess_pres_link.presentation_id)
                    sessionroles.forEach(role => {
                        let person = data['persons'].filter(person => person.id == role.person_id)[0];
                        if (person) {
                            person.function = role.function;
                            if (JSON.stringify(session.chair).indexOf(person.id) == -1) {
                                session.chair.push(person);
                            }
                        }
                    })
                    presroles.forEach(role => {
                        let person = data['persons'].filter(person => person.id == role.person_id)[0];
                        if (person) {
                            person.function = role.function;
                            if (JSON.stringify(session.speakers).indexOf(person.display_name) == -1) {
                                session.speakers.push(person);
                            }
                        }
                    })
                })
            } else {
                let sessionroles = data['person_roles'].filter(sessrole => sessrole.session_id == session.id)
                sessionroles.forEach(role => {
                    let person = data['persons'].filter(person => person.id == role.person_id)[0];
                    if (person) {
                        person.function = role.function;
                        if (JSON.stringify(session.chair).indexOf(person.id) == -1) {
                            session.chair.push(person);
                        }
                    }
                })
            }
            sessionsToReturn.push(session);

        })


        return sessionsToReturn;
    }

}
const mutations = {}
const getters = {}

export const sessiontypes = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
